





























import Vue from "vue";
import { required, minLength, sameAs } from "vuelidate/lib/validators";

import permission, { PermissionName } from "@/common/mixins/permission";
import dialog from "@/common/mixins/dialog";
import UserFormEditPassword from "../components/UserFormEditPassword.vue";
import { UserSetPasswordForm } from "../forms/UserSetPasswordForm";
export default Vue.extend({
  mixins: [permission, dialog],
  components: {
    UserFormEditPassword
  },
  validations: {
    userSetPasswordForm: {
      passwordForm: {
        password: {
          required,
          minLength: minLength(6)
        },
        confirmPassword: {
          sameAsPassword: sameAs("password")
        }
      }
    }
  },
  data() {
    const userSetPasswordForm: UserSetPasswordForm = {
      passwordForm: {
        password: "",
        confirmPassword: ""
      }
    };
    return { userSetPasswordForm };
  },
  async created() {
    await Promise.all([this.getUserById(+this.$route.params.id)]);
  },
  computed: {
    hasUserViewPermission() {
      return (this as any).hasPermission(PermissionName.USER_VIEW);
    }
  },
  methods: {
    async getUserById(id: number) {
      try {
        const { data } = await (this as any).$dep.userUseCase.getUser(id);
        this.userSetPasswordForm = { ...this.userSetPasswordForm, user: data };
      } catch (error) {
        console.log(error.response);
      }
    },
    async setPasswordUser() {
      try {
        await (this as any).$dep.userUseCase.setPasswordUser(
          this.userSetPasswordForm
        );
        if (
          await (this as any).alertSuccess("Success", "Reset Password สำเร็จ")
        ) {
          this.goToUserViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError("Error", "ไม่สามารถ Reset Password ได้")
            : (this as any).alertError("Error", error);
        }
      }
    },
    goToUserViewPage() {
      this.$router.push({ name: "UserViewPage" });
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to reset password",
        "คุณต้องการรีเซ็ต password หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.setPasswordUser();
      }
    },
    clear() {
      this.$v.$reset();
      this.userSetPasswordForm = {
        ...this.userSetPasswordForm,
        passwordForm: {
          password: "",
          confirmPassword: ""
        }
      };
    }
  }
});
